export default Object.freeze({
  CUSTOMER_PROFILE: 'customer',
  CONVERSATION: 'conversation',
  USER: 'user',
});
